import {
  ApplicationConfig,
  inject,
  PLATFORM_ID,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import {
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideLottieOptions } from 'ngx-lottie';
import { provideTranslateService } from '@ngx-translate/core';
import { initSwiper } from './utils/swipper-registerer';

function getHydrationProvider() {
  return typeof window !== 'undefined'
    ? provideClientHydration(withEventReplay())
    : provideClientHydration();
}

export const appConfig: ApplicationConfig = {
  providers: [
    getHydrationProvider(),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideTranslateService(),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
    provideAppInitializer(() => {
      const platformId = inject(PLATFORM_ID);
      initSwiper(platformId)();
    }),
  ],
};
